import React from "react";
import FocusVideo from "./videoPlayer";
import AlbowGardensVid from './images/AlbowGardens/ALBOW_GARDENS.mp4';


import image1 from './images/AlbowGardens/ALBOWGARDENS_001 Large.jpeg';
import image2 from './images/AlbowGardens/ALBOWGARDENS_002 Large.jpeg';
import image3 from './images/AlbowGardens/ALBOWGARDENS_004 Large.jpeg';
import image4 from './images/AlbowGardens/ALBOWGARDENS_005 Large.jpeg';
import image5 from './images/AlbowGardens/ALBOWGARDENS_006 Large.jpeg';
import image6 from './images/AlbowGardens/ALBOWGARDENS_009 Large.jpeg';
import image7 from './images/AlbowGardens/ALBOWGARDENS_010 Large.jpeg';
import image8 from './images/AlbowGardens/ALBOWGARDENS_013 Large.jpeg';
import image9 from './images/AlbowGardens/ALBOWGARDENS_020 Large.jpeg';
import image10 from './images/AlbowGardens/ALBOWGARDENS_021 Large.jpeg';
import image11 from './images/AlbowGardens/ALBOWGARDENS_023 Large.jpeg';
import image12 from './images/AlbowGardens/ALBOWGARDENS_030 Large.jpeg';
import image13 from './images/AlbowGardens/ALBOWGARDENS_032 Large.jpeg';
import image14 from './images/AlbowGardens/ALBOWGARDENS_036 Large.jpeg';
import image15 from './images/AlbowGardens/ALBOWGARDENS_037 Large.jpeg';
import image16 from './images/AlbowGardens/ALBOWGARDENS_038 Large.jpeg';
import image17 from './images/AlbowGardens/ALBOWGARDENS_041 Large.jpeg';
import image18 from './images/AlbowGardens/ALBOWGARDENS_042 Large.jpeg';
import image19 from './images/AlbowGardens/ALBOWGARDENS_043 Large.jpeg';
import image20 from './images/AlbowGardens/ALBOWGARDENS_052 Large.jpeg';
import image21 from './images/AlbowGardens/ALBOWGARDENS_054 Large.jpeg';
import image22 from './images/AlbowGardens/ALBOWGARDENS_056 Large.jpeg';
import image23 from './images/AlbowGardens/ALBOWGARDENS_059 Large.jpeg';
import image24 from './images/AlbowGardens/ALBOWGARDENS_060 Large.jpeg';
import image25 from './images/AlbowGardens/ALBOWGARDENS_065 Large.jpeg';

const Books = () => {
    return (
        
    <div className="picture-gallery">
        <div className="photo-column">
            <div className="single">
                <img src={image1}/>
            </div>
            <div className="single">
                <img src={image2}/>
            </div>
            <div className="single">
                <img src={image3}/>
            </div>
            <div className="single">
                <img src={image4}/>
            </div>
            <div className="single">
                <img src={image5}/>
            </div>
            <div className="single">
                <img src={image6}/>
            </div>
            <div className="single">
                <img src={image7}/>
            </div>
            <div className="single">
                <img src={image8}/>
            </div>
            <div className="single">
                <img src={image9}/>
            </div>
            <div className="single">
                <img src={image10}/>
            </div>
            <div className="single">
                <img src={image11}/>
            </div>
            <div className="single">
                <img src={image12}/>
            </div>
            <div className="single">
                <img src={image13}/>
            </div>
            <div className="single">
                <img src={image14}/>
            </div>
            <div className="single">
                <img src={image15}/>
            </div>
            <div className="single">
                <img src={image16}/>
            </div>
            <div className="single">
                <img src={image17}/>
            </div>
            <div className="single">
                <img src={image18}/>
            </div>
            <div className="single">
                <img src={image19}/>
            </div>
            <div className="single">
                <img src={image20}/>
            </div>
            <div className="single">
                <img src={image21}/>
            </div>
            <div className="single">
                <img src={image22}/>
            </div>
            <div className="single">
                <img src={image23}/>
            </div>
            <div className="single">
                <img src={image24}/>
            </div>
            <div className="single">
                <img src={image25}/>
            </div>
            <FocusVideo src={AlbowGardensVid} />
            <div className="single text">
                <div className="text right">
                    Albow Gardens will be published by Gost Books in May 2026.
                </div>
            </div>
            <div className="single text">
                <div className="text">
                    Large families need to be held together. 
                    <br/>
                    <br/>
                    I have been trying my whole life. 
                    <br/>
                    For others, 
                    <br/>
                    for me. 
                    <br/>
                    <br/>
                    I don’t sleep. 
                    <br/>
                    <br/>
                </div>
            </div>
           
            <div className="single text">
                <div className="text fs-height">
                   The bricks of the buildings are harder here,
                   <br/>
                    they seem to jut out, as if their edges were more pronounced.
                    <br/>
                    The red leans toward rust;
                    <br/>
                    the sun, instead of illuminating it, seems to darken it,
                    <br/>
                    almost as if trying to wear it away.
                    <br/>
                    The greys, instead, are always either too dark or too light,
                    <br/>
                    without compromise, without seduction.
                    <br/>
                    <br/>

                    What pushed me away for being so different, at the same time created friction;
                    <br/>
                    everything that struck me as severe felt instead more real, more permanent.
                    <br/>
                    <br/>

                    I saw the buildings from afar, they were grey;
                    <br/>
                    I came closer, and each one had a letter of the alphabet painted on it,
                    <br/>
                    large as a person.
                    <br />
                    <br />

                    I walked and looked through the fence without seeing anyone,
                    <br />
                    only common areas with concrete bases for grilling,
                    <br />
                    sand inside them, the wind lifting it up, and the sun hitting it straight on.
                    <br />
                    <br />

                    A little further on there was a woman,
                    <br />
                    she had short poppy-red hair, fair skin and blue eyes;
                    <br />
                    she looked at me through the metal bars that still stood between us
                    <br />
                    while sweeping leaves outside.
                    <br />
                    That’s how I met Natty; through her, I entered Albow Gardens.
                    <br />
                    <br />

                    I don’t remember a day without wind among those buildings;
                    <br />
                    it moved through the courtyards and the gardens that never grew,
                    <br />
                    dragging everything along at waist height.
                    <br />
                    <br />

                    Many stayed inside their homes,
                    <br />
                    lying on their couches with the doors wide open,
                    <br />
                    the music worn down by the volume of the subwoofers;
                    <br />
                    others walked through the courtyards, dragged along by their dogs,
                    <br />
                    still wearing animal-print onesies,
                    <br />
                    sometimes tigers, sometimes zebras,
                    <br />
                    with no distinction between day and night.
                    <br />
                    <br />

                    Only the cats against the warm window glass,
                    <br />
                    and the children up in the trees, moved time.
                    <br />
                    Cecil, instead, looked out at life from above,
                    <br />
                    from the second floor of building G,
                    <br />
                    searching for it among the buildings, in the corridors, in the narrowest corners;
                    <br />
                    waiting for the sun to become a star.
                    <br />
                    <br />

                    He laughed at me, his voice more like a whistle,
                    <br />
                    wearing a pair of cut-off jeans, tight at the knees,
                    <br />
                    made from old denim.
                    <br />
                    Above, he was a giant, shirtless, his body white as milk,
                    <br />
                    the mark of the sun from the neck up;
                    <br />
                    he looked strangled.
                    <br />
                    <br />

                    It was the first time I had gone up that high;
                    <br />
                    through the gaps in the stairwell, I could see Table Mountain.
                    <br />
                    <br />

                    We sat down on the couch;
                    <br />
                    I had not yet entered anyone’s home.
                    <br />
                    <br />

                    The walls were blue and the cupboards yellow.
                    <br />
                    <br />

                    The children cut through the space between us,
                    <br />
                    two, three, four, seven, I kept count.
                    <br />
                    <br />

                    Bianca, his wife, was lying on the bed;
                    <br />
                    beside her was Junior, leaning against the window with Lollipop, their cat.
                    <br />
                    <br />

                    Summer light came through, along with strips of curtains.
                    <br />
                    <br />

                    Jamie looked at me; she smiled, holding onto her father.
                    <br />
                    <br />

                    It was a day of celebration, it was Saturday;
                    <br />
                    there was a birthday cake, we ate it with our fingers.
                    <br />
                    <br />

                </div>
            </div>
        </div>
    </div>
    );
}

export default Books;